import { useEffect } from "react";
import { Card, CardHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useNewTable } from "../../../components/NTable/hook";
import NTable from "../../../components/NTable";
import InfoModal from "./InfoModal";
import { useColumns } from "./columns";
import { useBatchJobsApi } from "./api";
import { useQueryFilters } from "../../Settings/helpers/useQueryFilters";
import { useVisible } from "../../../utils/hooks/useVisible";

function Batch() {
    const { t } = useTranslation();
    const { visible, open, close, selected } = useVisible();
    const { get, loading, data, totalItems } = useBatchJobsApi();

    const columns = useColumns({ open });

    const table = useNewTable({
        data,
        columns,
        totalItems,
        enableRowSelection: false,
        loading
    });

    const queryFilters = useQueryFilters(table);

    useEffect(() => {
        const controller = new AbortController();
        get(controller);
        return () => controller.abort();
    }, [get, queryFilters]);


    return (
        <Card className="h-100 w-100">
            <CardHeader>
                <h4 className="mb-0">{t("batch-jobs")}</h4>
            </CardHeader>
            
            <NTable table={table} />

            <InfoModal
                values={selected}
                isOpen={visible}
                close={close}
            />
        </Card>
    );
};

export default Batch;
